/* eslint-disable */
import axios from '@/services/axios'

export default {
    listFirstClass(search, source) {
        return axios.get("/competition/getFirstClasses", { params: search, cancelToken: source.token });
    },
    getmiddleclasslist(search, source) {
        return axios.get("/competition/getMiddleClasses", { params: search, cancelToken: source.token });
    },
    listFirstAttribute(search, source){
        return axios.get("/competition/getFirstAttributes", { params: search, cancelToken: source.token });
    },
    listSecondAttribute(search, source) {
        return axios.post("/competition/getSecondAttributes", search, { cancelToken: source.token });
    },
    getCompetitionDataDonutBar(search, source) {
        return axios.get("/competition/getCompetitionDataDonutBar", { params: search, cancelToken: source.token });
    },
    getCompetitionDataLine(search, source) {
        return axios.post("/competition/getCompetitionDataLine", search, { cancelToken: source.token });
    },
    getCompetitionDataTable(search, source) {
        return axios.post("/competition/getCompetitionDataTable", search, { cancelToken: source.token });
    },
    getCompetitionDataTableExp(search, source) {
        return axios.post("/competition/getCompetitionDataTableExp", search, { cancelToken: source.token });
    },
};
